import * as React from 'react';
// import FormControl from '@mui/material/FormControl';
// import { TextField } from '@mui/material';
// import { MultipleSelectChip } from './MultipleSelectChip';
import { SingleSelectInput } from './Location';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

export function Primary({ filters, updateState }) {
    const autoFill = [
        {
            id: 'Draft',
            name: 'Draft',
        },
        {
            id: 'Rejected (Corrections needed)',
            name: 'Rejected (Corrections needed)',
        },
        {
            id: 'Available',
            name: 'Available',
        },
        {
            id: 'Issued to someone',
            name: 'Issued to someone',
        },
        {
            id: 'Used by',
            name: 'Used by',
        },
    ];

    return (
        <div className='attirubutes-filter-container'>
            {/* <div className='input-container'>
                <FormControl size="small" fullWidth={true}>
                    <TextField value={filters.Search} onChange={e => updateState({ "Search": e.target.value })} size='small' fullWidth label="Search by swatch code or any attribute" id="fullWidth" />
                </FormControl>
            </div> */}
            <div className='input-container'><SingleSelectInput options={autoFill} value={filters.Status} updateState={updateState} filterKey="Status" inputName="Status" /> </div>
            <div className='input-container'>
                <Box>
                    <FormControl size="small" fullWidth>
                        <InputLabel id="yet-to-be-filter-label">Yet to be:</InputLabel>
                        <Select
                            labelId="yet-to-be-filter-label"
                            id="yet-to-be-filter"
                            value={filters.cdnullorzero___first_approved_on || ''}
                            label="Yet to be:"
                            onChange={(event) => updateState({ cdnullorzero___first_approved_on: event.target.value })}
                        >
                            <MenuItem value="">None</MenuItem>
                            <MenuItem value="1">Approved</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
            </div>

            {/* <div className='input-container'>
                
                <MultipleSelectChip filterKey="Status" value={filters["Status"]} options={autoFill} updateState={updateState} inputName={"Status"} />
            </div> */}
        </div>
    );
}
